<template>
  <div class="show_all_content_wrapper">
    <!-- Start:: Main Section -->
    <main>
      <!--  =========== Start:: Table Title =========== -->
      <div class="table_title_wrapper">
        <div class="title_text_wrapper">
          <h5>{{ $t("PLACEHOLDERS.Overall_statistics") }}</h5>
        </div>
      </div>
      <!--  =========== End:: Table Title =========== -->

      <!--  =========== Start:: Data Table =========== -->
      <div class="statics mt-4" v-if="statics && Object.keys(statics).length">
        <div class="row">
          <div
            class="col-lg-6 col-md-6 col-12"
            v-for="(value, key) in statics"
            :key="key"
          >
            <div
              class="box"
              @click="navigateToPage(key)"
              :style="{
                cursor: key !== 'offers_count' ? 'pointer' : 'default',
              }"
            >
              <div class="icon">
                <i v-if="key === 'points'" class="fas fa-coins"></i>
                <i
                  v-else-if="key === 'orders_count'"
                  class="fas fa-shopping-cart"
                ></i>
                <i v-else-if="key === 'offers_count'" class="fas fa-tags"></i>
                <i
                  v-else-if="key === 'chats_count'"
                  class="fas fa-comments"
                ></i>
              </div>

              <div class="info_box">
                <span v-if="key === 'points'">{{
                  $t("PLACEHOLDERS.points")
                }}</span>
                <span v-else-if="key === 'orders_count'">{{
                  $t("PLACEHOLDERS.orders_count")
                }}</span>
                <span v-else-if="key === 'offers_count'">{{
                  $t("PLACEHOLDERS.offers_count")
                }}</span>
                <span v-else-if="key === 'chats_count'">{{
                  $t("PLACEHOLDERS.chats_count")
                }}</span>

                <p class="number_box">{{ value }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!--  =========== End:: Data Table =========== -->
      <!-- <coming-soon v-else /> -->
    </main>
    <!-- End:: Main Section -->
  </div>
</template>

<script>
import ComingSoon from "@/components/ui/ComingSoon.vue";

export default {
  name: "HomePage",

  components: {
    ComingSoon,
  },

  data() {
    return {
      statics: [],
    };
  },

  methods: {
    showLoginCountNotice() {
      const loginCount = Number(
        JSON.parse(
          localStorage.getItem("bonian_provider_login_count") ?? "null"
        )
      );
      console.log("Login Count:", loginCount); // Debugging log
      if (loginCount == 1 || loginCount == 2) {
        this.$warning({
          title: this.$t("MESSAGES.loginEmailNoticeTitle"),
          content: this.$t("MESSAGES.loginEmailNoticeContent"),
          okText: this.$t("BUTTONS.ok"),
        });

        localStorage.removeItem("bonian_provider_login_count");
      }
    },

    async getStatics() {
      try {
        let res = await this.$axios({
          method: "GET",
          url: "statistics",
        });

        this.statics = {
          points: res.data.data.points,
          orders_count: res.data.data.orders_count,
          offers_count: res.data.data.offers_count,
          chats_count: res.data.data.chats_count,
        };
      } catch (error) {
        console.log(error.response?.data?.message);
      }
    },
    navigateToPage(key) {
      const routes = {
        orders_count: "/orders/all",
        chats_count: "/live-chat/all",
        offers_count: null,
        points: "/referralcodes/all",
      };

      if (routes[key]) {
        this.$router.push(routes[key]);
      }
    },
  },

  mounted() {
    this.showLoginCountNotice();
    this.getStatics();
  },
};
</script>

<style lang="scss" scoped>
.show_all_content_wrapper {
  .statics {
    .box {
      background: #f47e2a;
      padding: 25px;
      margin-bottom: 10px;
      border-radius: 5px;
      overflow: hidden;
      display: flex;
      justify-content: space-between;

      transition: all 0.5s;

      &:hover {
        background: #fff;
        box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);

        .icon {
          i {
            color: #f47e2a;
          }
        }
        .info_box {
          span,
          p.number_box {
            color: #000;
          }
        }
      }

      .icon {
        height: 60px;
        min-width: 60px;
        width: 60px;
        border-radius: 60px;
        background: #fff;
        display: flex;
        align-items: center;
        justify-content: center;

        i {
          font-size: 25px;
          color: #000;
        }
      }

      .info_box {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: flex-end;

        span {
          font-size: 19px;
          color: #fff;
        }

        p.number_box {
          font-size: 30px;
          color: #fff;
          font-weight: bold;
        }
      }
    }
  }
}
.show_all_content_wrapper .statics .box .info_box {
  align-items: flex-start !important;
  width: 100% !important;
  padding-inline-start: 5% !important;
}
</style>
